<template>
  <div class="devices-tab">
    <v-data-table
      :headers="headers"
      :items="devices"
      hide-default-footer
      fixed-header
      height="500"
      :items-per-page="-1"
      class="mb-6"
    >
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Appareils</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template #activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nouveau</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-validate="'required'"
                        data-vv-name="label"
                        :error="errors.has('label')"
                        v-model="editedItem.label"
                        label="Libellé"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-validate="'required'"
                        data-vv-name="family"
                        :error="errors.has('family')"
                        label="Famille"
                        v-model="editedItem.family"
                        :items="familyItems"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-validate="'required'"
                        data-vv-name="fixed_price"
                        :error="errors.has('fixed_price')"
                        v-model.number="editedItem.fixed_price"
                        label="Prix fixe"
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="save"
                  >Enregistrer</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Family -->
      <template #item.family="{ value }">
        {{ productsObject[value].name }}
      </template>

      <!-- Fixed price -->
      <template #item.fixed_price="{ value }">
        {{ value | currency }}
      </template>

      <!-- Actions -->
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import DevicesRepo from "@/repositories/settings/devices";
  import { productsObject } from "@/utils/products";

  export default {
    name: "DevicesTab",
    data() {
      return {
        headers: [
          {
            text: "Libellé",
            align: "left",
            value: "label"
          },

          {
            text: "Famille",
            align: "left",
            value: "family"
          },

          {
            text: "Prix fixe",
            align: "left",
            value: "fixed_price"
          },

          {
            text: "Actions",
            value: "action",
            sortable: false
          }
        ],

        devices: [],

        productsObject: productsObject,

        familyItems: [
          { text: "Minerve", value: "NECK_BRACE" },
          { text: "Corset", value: "CORSET" },
          { text: "Vertic", value: "LIFT" },
          { text: "OTN", value: "OTN" },
          { text: "Selle de positionnement", value: "POSITIONING_SEAT" },
          { text: "Retouche/Réparation", value: "RETOUCHING_REPAIR" },
          { text: "Selle ", value: "SEAT" },
          { text: "Orthèse Sup ", value: "UPPER_LIMB_ORTHOSIS" },
          { text: "Orthèse Inf ", value: "LOWER_LIMB_ORTHOSIS" },
          { text: "Siège moulé ", value: "MOLDED_SEAT" }
        ],

        defaultItem: {
          label: null,
          familly: "CORSET",
          fixed_price: null
        },

        dialog: false,
        editedId: -1,
        editedItem: {
          label: null,
          familly: "CORSET",
          fixed_price: null
        }
      };
    },
    computed: {
      formTitle() {
        return this.editedId === -1
          ? "Ajouter un appareil"
          : "Modifier un appareil";
      }
    },
    methods: {
      editItem(item) {
        this.editedId = item.id;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      /**
       * Delete a device
       */
      async deleteItem(item) {
        confirm("Voulez-vous supprimer cet appareil?") &&
          (await DevicesRepo.deleteDevice(item.id));

        this.getDevices();
      },

      /**
       * Save device on server
       */
      async save() {
        // Check if form is valid
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          return;
        }

        if (this.editedId > -1) {
          await DevicesRepo.updateDevice(this.editedId, this.editedItem);
        } else {
          await DevicesRepo.create(this.editedItem);
        }

        this.getDevices();
        this.close();
      },

      /**
       * Close dialog and reset edited item
       */
      close() {
        this.dialog = false;
        this.errors.clear();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedId = -1;
        }, 300);
      },

      /**
       * Get all devices
       */
      async getDevices() {
        try {
          const { data } = await DevicesRepo.get();
          this.devices = data;
        } catch (error) {
          alert(error);
        }
      }
    },
    created() {
      this.getDevices();
    }
  };
</script>

<style lang="scss">
  .supports-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
    .v-data-table table tr td {
      height: auto !important;
    }
    .v-data-table table tbody td .v-input .v-input__control .v-input__slot {
      height: auto !important;
    }
  }
</style>
